import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { formatCurrency } from '../custom-hooks';
import { isAfricanCountry } from '../../utils/constants';

interface Props {
    price: number,
    altPrice: number,
    program: string,
    description: string,
    features?: string[],
    id: any,
    setSelected?: (data:any) => void,
    selected?: any,
    minAge: number,
    maxAge: number,
    duration: number,
    country: any
}

export default function ProgramCard({ price, program, description, minAge, maxAge, duration, country, altPrice }: Props) {
    const currencyInfo =  useSelector((state: RootState) => state.user.currency);
    const  [ currency, setCurrency ] = useState<any>(null);

    useEffect(() => {
        if(currencyInfo && currencyInfo?.useRate){
            setCurrency(currencyInfo);
        }
    }, [currencyInfo]);

    const displayPrice = currency
        ? formatCurrency((isAfricanCountry(country) ? altPrice : price) * (currency?.rate || 1))
        : formatCurrency(price);

    return (
        <div className="rounded-[16px] border border-[#efe6f1] bg-[#FBF8FC] p-5 sm:p-6">
            <p className="text-[12px] font-semibold uppercase tracking-wide text-ryd-primary">Selected program</p>
            <h1 className="mt-1 font-[AvertaStd-Semibold] text-[20px] capitalize leading-tight text-ryd-headerTextPrimary sm:text-[22px]">
                {program}
            </h1>
            <p className="mt-2 text-[13px] leading-relaxed text-[#8b9aab] sm:text-[14px]">{description}</p>

            <div className="mt-4 grid grid-cols-2 gap-3">
                <div className="rounded-[12px] border border-[#efe6f1] bg-white px-3 py-2.5">
                    <p className="text-[11px] font-medium uppercase tracking-wide text-[#94a3b8]">Age range</p>
                    <p className="mt-0.5 text-[14px] font-semibold text-[#334155]">{minAge}–{maxAge} yrs</p>
                </div>
                <div className="rounded-[12px] border border-[#efe6f1] bg-white px-3 py-2.5">
                    <p className="text-[11px] font-medium uppercase tracking-wide text-[#94a3b8]">Duration</p>
                    <p className="mt-0.5 text-[14px] font-semibold text-[#334155]">{duration} weeks</p>
                </div>
            </div>

            <div className="mt-4 hidden items-baseline gap-1 border-t border-[#efe6f1] pt-3">
                <span className="text-[13px] text-[#8b9aab]">{currency ? currency?.currencyCode : 'CAD'}</span>
                <span className="font-[AvertaStd-Semibold] text-[22px] text-ryd-primary">{displayPrice}</span>
                <span className="text-[12px] text-[#8b9aab]">/month</span>
            </div>
        </div>
    )
}
